import { ICellRendererAngularComp } from "@ag-grid-community/angular";
import { ICellRendererParams } from "@ag-grid-community/core";
import { ChangeDetectionStrategy, Component, signal } from "@angular/core";
import {
  BulkUploadRowPreview,
  SupportedBulkUploadEntityModel,
} from "@m19-board/services/bulk-upload/bulk-upload-context.service";
import { BulkUploadPreviewStatus, BulkUploadTypeIconComponent } from "./bulk-upload-type-icon.component";

@Component({
  selector: "app-bulk-upload-type-icon-grid",
  host: {
    class: "inline-block",
  },
  imports: [BulkUploadTypeIconComponent],
  template: `
    @if (type(); as type) {
      <app-bulk-upload-type-icon [type]="type" [tooltip]="tooltip()" />
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BulkUploadTypeIconGridComponent implements ICellRendererAngularComp {
  type = signal<BulkUploadPreviewStatus | undefined>(undefined);
  tooltip = signal<string | undefined>(undefined);

  agInit(
    params: ICellRendererParams<BulkUploadRowPreview<SupportedBulkUploadEntityModel>> & {
      type: BulkUploadPreviewStatus;
      tooltip?: string;
    },
  ): void {
    this.type.set(params.data?.status);
    this.tooltip.set(params.tooltip);
  }

  refresh(_: ICellRendererParams<BulkUploadRowPreview<SupportedBulkUploadEntityModel>>): boolean {
    return true;
  }
}
